/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/field_extract.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Extracts the value of a single sub-field from a `flattened` field root as `keyword`.
 *
 * @example
 * FROM flattened_otel_logs
 * | WHERE @timestamp == "2020-01-01T00:02:48.461Z"
 * | EVAL hn = field_extract(resource.attributes, "host.name")
 * | KEEP hn
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'field_extract',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'flattened',
          optional: false,
        },
        {
          name: 'path',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'field',
          type: 'flattened',
          optional: false,
        },
        {
          name: 'path',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
